import { css } from '@emotion/react'
import React from 'react'

import { cn } from '@/lib/utils'

const Main: React.FC<React.HTMLAttributes<HTMLDivElement>> = (props) => (
  <main
    {...props}
    className={cn('flex min-h-screen w-full min-w-0 flex-col', props.className)}
    css={css`
      transition:
        margin-left 0.35s ease-in-out,
        left 0.35s ease-in-out,
        margin-right 0.35s ease-in-out,
        right 0.35s ease-in-out;
    `}
  >
    {props.children}
  </main>
)

export default Main
